import { Termin } from '@/domain/termine/shared/types/Termin';
import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@e2n/ui';
import { TerminInfo } from '@/domain/termine/features/Calendar/shared/TerminInfo/TerminInfo';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// oxlint-disable-next-line complexity
export function TerminPopoverContent({
  termin,
  onDeleteClick,
}: {
  termin: Termin;
  onDeleteClick: () => void;
}) {
  const { t } = useTranslation();
  const { year, month } = useParams();

  const isDeleteDisabled =
    termin.arbeitszeiten.length > 0 ||
    termin.schichten.length > 0 ||
    termin?.hasHiddenSchichten ||
    termin?.hasHiddenArbeitszeiten;

  return (
    <div className="w-full max-h-112.5 overflow-y-auto p-4 rounded-lg">
      <TerminInfo termin={termin} />
      <div className="flex justify-end items-center mt-5">
        <Button asChild size="sm" variant="ghost">
          <Link
            to={`/termine/uebersicht/${year}/${month}/edit/${termin.id}`}
            state={{ datum: termin.datum }}>
            <FontAwesomeIcon className="text-primary-blue-600" icon={faEdit} />
          </Link>
        </Button>
        <Tooltip>
          <TooltipTrigger asChild>
            <span>
              <Button
                size="sm"
                variant="ghost"
                onClick={onDeleteClick}
                disabled={isDeleteDisabled}>
                <FontAwesomeIcon
                  className={
                    isDeleteDisabled
                      ? 'text-neutrals-400'
                      : 'text-primary-red-400'
                  }
                  icon={faTrashCan}
                />
              </Button>
            </span>
          </TooltipTrigger>
          {isDeleteDisabled && (
            <TooltipContent className="whitespace-pre-line">
              {t('domain.termine.deleteWithHiddenArbeitsbereich')}
            </TooltipContent>
          )}
        </Tooltip>
      </div>
    </div>
  );
}
